module.exports = __webpack_public_path__ + "static/media/202-norfolk-island.39f79eda.svg";